export default __webpack_public_path__ + "static/media/info-button.6bae4dea.svg";